/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} British_EnglishInputs */



/**
* | output |
* | --- |
* | "British English" |
*
* @param {British_EnglishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const british_english = /** @type {((inputs?: British_EnglishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<British_EnglishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Anglais britannique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Britisches Englisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inglese britannico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Британский английский")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inglés británico")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("英国英语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イギリス英語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ब्रिटिश अंग्रेज़ी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inglês britânico")
	return /** @type {LocalizedString} */ ("British English")
});